<div class='tile-message {{color_class}}'>
    <h3>{{title}}</h3>
    <p>{{{text}}}</p>
</div>
